import { z } from 'zod';
export const documentsNotificationRequestsCapability = 'documents.notification-requests.v1';
export const documentsWorkforceProtectedFormNotificationEventName = 'documents.workforce-protected-form-notification-requested.v1';
export const documentsKnowledgeSignedPolicyCopyNotificationEventName = 'documents.knowledge-signed-policy-copy-notification-requested.v1';
export const documentsWorkforceProtectedFormNotificationPayloadSchema = z.strictObject({
    notificationKind: z.literal('workforce-protected-form-submitted'),
    subjectMembershipId: z.string().uuid(),
    directRecipientMembershipIds: z.tuple([z.string().uuid()]),
    recipientRoleKeys: z.tuple([z.literal('manager'), z.literal('owner')]),
    requestedChannels: z.tuple([z.literal('email'), z.literal('in-app')]),
    submissionId: z.string().uuid(),
    definitionId: z.string().uuid(),
    definitionVersionId: z.string().uuid(),
    definitionVersionNumber: z.number().int().positive(),
    submittedAt: z.string().datetime({ offset: true }),
    actionPath: z.literal('/documents/employee-forms'),
    protectedContentExcluded: z.literal(true),
    emailAttachmentsAllowed: z.literal(false),
}).superRefine((payload, context) => {
    if (payload.directRecipientMembershipIds[0] !== payload.subjectMembershipId) {
        context.addIssue({
            code: 'custom',
            message: 'The protected-form subject must be the direct notification recipient.',
            path: ['directRecipientMembershipIds', 0],
        });
    }
});
export const documentsKnowledgeSignedPolicyCopyNotificationPayloadSchema = z.strictObject({
    notificationKind: z.literal('knowledge-signed-policy-copy'),
    subjectMembershipId: z.string().uuid(),
    directRecipientMembershipIds: z.tuple([z.string().uuid()]),
    recipientRoleKeys: z.tuple([]),
    requestedChannels: z.tuple([z.literal('email'), z.literal('in-app')]),
    artifactId: z.string().uuid(),
    documentId: z.string().uuid(),
    versionId: z.string().uuid(),
    versionNumber: z.number().int().positive(),
    title: z.string().trim().min(1).max(250),
    signedAt: z.string().datetime({ offset: true }),
    actionPath: z.literal('/documents/signed-policies'),
    copyMode: z.literal('secure-crest-readback'),
    signatureContentExcluded: z.literal(true),
}).superRefine((payload, context) => {
    if (payload.directRecipientMembershipIds[0] !== payload.subjectMembershipId) {
        context.addIssue({
            code: 'custom',
            message: 'The signed-policy subject must be the direct notification recipient.',
            path: ['directRecipientMembershipIds', 0],
        });
    }
});
export const documentsNotificationPayloadSchema = z.discriminatedUnion('notificationKind', [
    documentsWorkforceProtectedFormNotificationPayloadSchema,
    documentsKnowledgeSignedPolicyCopyNotificationPayloadSchema,
]);
//# sourceMappingURL=documents-notification-request.contract.js.map